import { format, differenceInCalendarDays, parseISO } from "date-fns";

/** Clé de jour locale "YYYY-MM-DD" (utilisée pour les séries et l'activité). */
export function dayKey(d: Date = new Date()): string {
  return format(d, "yyyy-MM-dd");
}

export function daysBetween(dayA: string, dayB: string): number {
  return differenceInCalendarDays(parseISO(dayB), parseISO(dayA));
}

export function monthKey(d: Date = new Date()): string {
  return format(d, "yyyy-MM");
}
